import React from 'react'

import LegacyEmptyState from '../EmptyStateOld'
import DocumentListEmptyState from '../DocumentListEmptyState'
import { useFolderTerm } from '@sketch/modules-common'

const TITLE = 'Trash is empty'

interface TrashListEmptyStateProps {
  search?: string
}

const TrashListEmptyState = ({ search }: TrashListEmptyStateProps) => {
  const folderTerm = useFolderTerm()

  if (search) {
    return (
      <LegacyEmptyState
        title={TITLE}
        description={`Documents and ${folderTerm.lower}s in Trash are permanently deleted after 90 days.`}
        search={search}
      />
    )
  }

  return (
    <DocumentListEmptyState
      title={TITLE}
      description={`Move any unwanted documents or ${folderTerm.lower}s here.`}
    />
  )
}

export default TrashListEmptyState
